import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'service',
    name: 'service',
    component: Form,
    redirect: { name: 'service-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'service-list',
        component: () => import('@/views/service/ServiceList.vue'),
        meta: {
          header: {
            label: () => i18n.t('title.list', [i18n.tc('service.label', 2)]),
          },
        },
      },
      {
        path: 'create',
        name: 'service-create',
        component: () => import('@/views/service/ServiceCreate.vue'),
        meta: {
          header: {
            route: { name: 'service-list' },
            label: () => i18n.t('title.create', [i18n.tc('service.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'service-edit',
        component: () => import('@/views/service/ServiceEdit.vue'),
        meta: {
          header: {
            route: { name: 'service-list' },
            label: () => i18n.t('title.edit', [i18n.tc('service.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
